import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import {
  Alert,
  Button,
  Checkbox,
  Col,
  Form,
  Icon,
  Input,
  message,
  Row,
  Select,
} from "antd";
import { withNamespaces } from "react-i18next";
import classes from "./WizardConfig.css";

import { postDelLogConfig } from "../../api/requests";
import { logout, setAppSettings } from "../../reducers/user/actions";

class DelLogConfigForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      delegationLogConfigData: {},
      isLoadingData: false,
      isLoading: false,
      drugDosageSettingsKeys: [],
      drugDosageSettingsValues: {},
      randomizationData: null,
      errorMessage: null,
    };
  }

  componentDidMount() {
    this.setData();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.delegationLogConfigData.is_configured !==
      this.props.delegationLogConfigData.is_configured
    ) {
      this.setData();
    }
  }

  setData = () => {
    this.setState({
      delegationLogConfigData: this.props.delegationLogConfigData,
    });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      errorMessage: null,
    });
    this.props.form.validateFields(async (err, values) => {
      const data = { ...values };

      this.props.form.setFields({
        qi_sign_before_staff: {
          value: values.qi_sign_before_staff,
          errors: null,
        },
      });
      this.props.form.setFields({
        qi_sign_after_staff: {
          value: values.qi_sign_after_staff,
          errors: null,
        },
      });

      try {
        await postDelLogConfig(data);
        message.success(this.props.i18n.t("Saved"));
        this.props.setAppSettings();
        this.props.onSubmit();
      } catch (e) {
        if (get(e, "response.data.errors")) {
          const errors = {};
          Object.keys(get(e, "response.data.errors")).forEach(
            (errorFieldKey) => {
              errors[errorFieldKey] = {
                value: values[errorFieldKey],
                errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                  (errorMessage) => new Error(errorMessage)
                ),
              };
            }
          );
          this.props.form.setFields(errors);
        } else {
          this.setState({
            errorMessage: JSON.stringify(get(e, "response.data.errors")),
          });
        }
        message.error(this.props.i18n.t("Error"));
        console.log(e);
      }
    });
  };

  render() {
    const {
      delegationLogConfigData,
      isLoading,
      isLoadingData,
      errorMessage,
    } = this.state;
    const { randomizationData, isDisabled } = this.props;
    const { getFieldDecorator } = this.props.form;
    const isRandomizeConfig =
      get(randomizationData, "treatment_groups", []).length > 0;
    const isEditable = isRandomizeConfig;

    return (
      <div className={classes.formWrapper}>
        <h3 className="headline-default">{this.props.i18n.t("NamespaceWizardConfig:Delegation Log Config")} </h3>

        {!isLoadingData ? (
          <Form onSubmit={this.handleSubmit}>
            <Row gutter={8}>
              <Col sm={24}>
                {!isRandomizeConfig && (
                  <Alert
                    type="warning"
                    message={this.props.i18n.t(
                      "NamespaceWizardConfig:Please fill Randomization Config first"
                    )}
                  />
                )}
              </Col>
            </Row>
            <Row gutter={8}>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("qi_sign_before_staff", {
                      initialValue: get(
                        delegationLogConfigData,
                        "qi_sign_before_staff",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:QI sign before staff")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>
              <Col sm={24}>
                <div>
                  <Form.Item>
                    {getFieldDecorator("qi_sign_after_staff", {
                      initialValue: get(
                        delegationLogConfigData,
                        "qi_sign_after_staff",
                        false
                      ),
                      valuePropName: "checked",
                    })(
                      <Checkbox disabled={!isEditable || isDisabled}>
                        <span style={{ fontSize: "16px" }}>
                          {this.props.i18n.t("NamespaceWizardConfig:QI sign after staff")}
                        </span>
                      </Checkbox>
                    )}
                  </Form.Item>
                </div>
              </Col>

              <Col sm={24}>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  <Form.Item label={this.props.i18n.t("Template type")}>
                    {getFieldDecorator(`default_template_type`, {
                      initialValue: get(delegationLogConfigData, `default_template_type`, null),
                    })(
                      <Select
                        disabled={!isEditable || isDisabled}
                        placeholder={this.props.i18n.t("Select")}
                      >
                        <Select.Option disabled value={null}>{this.props.i18n.t("Null")}</Select.Option>
                        <Select.Option value="long">{this.props.i18n.t("Long")}</Select.Option>
                        <Select.Option value="short">{this.props.i18n.t("Short")}</Select.Option>
                      </Select>
                    )}
                  </Form.Item>
                </div>
              </Col>

              <Col sm={24}>
                <b>{this.props.i18n.t("NamespaceWizardConfig:Protocol number")}</b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("protocol_number", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      delegationLogConfigData,
                      "protocol_number"
                    ),
                  })(<Input disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>

              <Col sm={24}>
                <b>{this.props.i18n.t("NamespaceWizardConfig:Document header text")}</b>
                <div style={{ margin: "0 0 30px", width: "250px" }}>
                  {getFieldDecorator("document_header_text", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(
                      delegationLogConfigData,
                      "document_header_text"
                    ),
                  })(<Input disabled={!isEditable || isDisabled} />)}
                </div>
              </Col>
            </Row>

            <br />
            <Row gutter={8}>
              {errorMessage && (
                <Col span={24}>
                  <Alert message={errorMessage} type="error" />
                </Col>
              )}
              <Col span={24}>
                <Button
                  disabled={!isEditable || isDisabled}
                  type="primary"
                  size="large"
                  htmlType="submit"
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
              </Col>
            </Row>
          </Form>
        ) : (
          <Icon type="loading" />
        )}
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { setAppSettings, logout };

export default Form.create({ name: "DelLogConfigForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DelLogConfigForm))
);



// WEBPACK FOOTER //
// ./src/containers/WizardConfig/DelLogConfigForm.js